import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";
import { useStyles } from "./HomePageStyleFooter";
import FooterInput from "./FooterInput";
import CopywriteFooter from "./CopywriteFooter";
import { useLocation, useNavigate } from "react-router-dom";

const HomePageFooter = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const email = "contact@sonabim.com";
  const emailSubject = "Demande d'information";

  const handleIndustryNavigate = () => {
    window.open("https://www.sonabim-industry.com/", "_blank");
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  return (
    <>
      <img src="bgMeettlak.png" width="100%" className={classes.bgMeettlak} />
      <Box className={classes.MainContainer}>
        {isHomePage && (
          <Box className={classes.FooterMainContainer}>
            <div data-aos="zoom-in-up">
              <Box container spacing={1} className={classes.FooterWrapper}>
                <Box item xs={12} sm={6} md={3}>
                  <img
                    src="SoonabimLogo.png"
                    alt=""
                    width="260px"
                    style={{ marginLeft: -12 }}
                  />
                  <Typography className={classes.FooterLogoText}>
                    Nous sommes les alchimistes du BIM, nous organisons les
                    systèmes de données en solutions innovantes pour l'énergie,
                    le transport & mobilité, et l'industrie complexe.
                  </Typography>
                </Box>

                <Box item xs={12} sm={6} md={2}>
                  <Typography variant="h6" className={classes.Heading}>
                    Votre Activité
                  </Typography>
                  <List>
                    <ListItem className={classes.ListItemWrapper}>
                      <a
                        href="https://travelbim.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.NavLinks}
                      >
                        <ListItemText
                          className={classes.ListItem}
                          primary="Transport & Mobilités"
                        />
                      </a>
                    </ListItem>

                    <ListItem
                      className={classes.ListItemWrapper}
                      onClick={handleIndustryNavigate}
                      style={{ cursor: "pointer" }}
                    >
                      <ListItemText
                        className={classes.ListItem}
                        primary="Production Industrielle"
                      />
                    </ListItem>
                  </List>
                </Box>

                <Box item xs={12} sm={6} md={2}>
                  <Typography variant="h6" className={classes.Heading}>
                    Contact
                  </Typography>
                  <List>
                    <ListItem className={classes.ListItemWrapper}>
                      <a
                        href={`mailto:${email}?subject=${encodeURIComponent(
                          emailSubject
                        )}`}
                        className={classes.EmailText}
                      >
                        {email}
                      </a>
                    </ListItem>
                    <ListItem className={classes.ListItemWrapper}>
                      <ListItemText
                        className={classes.ContactNumber}
                        primary="09.81.67.44.94"
                      />
                    </ListItem>
                  </List>
                </Box>

                <Box item xs={12} sm={6} md={2}>
                  <Typography variant="h6" className={classes.Heading}>
                    Newsletter
                  </Typography>
                  <ListItem className={classes.ListItemWrapper}>
                    <FooterInput />
                  </ListItem>
                </Box>
              </Box>
            </div>
          </Box>
        )}
        <CopywriteFooter />
      </Box>
    </>
  );
};

export default HomePageFooter;
